import { useEffect, useMemo } from 'react'
import useQueryState from '../../../../../../shared/hooks/useQueryState'
import { IEquipmentMaintenanceBlank } from '../../../../equipment.types'
import alertService from '../../../../../../services/alerts/alert.service'

const useViewMaintenanceBlankSidePageCtrl = (items: IEquipmentMaintenanceBlank[]) => {
  const [blankIdQuery, setBlankIdQuery] = useQueryState<number>('blankId', null)

  const blank = useMemo(() => {
    if (blankIdQuery == null || !items.length) return null
    return items.find((item) => item.id === +blankIdQuery)
  }, [blankIdQuery, items])

  useEffect(() => {
    if (blankIdQuery == null || !items.length) return
    const blankIndex = items.findIndex((item) => item.id === +blankIdQuery)
    if (blankIndex === -1) {
      setBlankIdQuery(null)
      alertService.requestAlert({
        type: 'error',
        title: 'Ошибка 404: Бланк ТО не найден!',
        description: 'Убедитесь, что вы перешли по правильной ссылке, либо обратитесь к администратору.',
      })
    }
  }, [blankIdQuery, items])

  return {
    blank,
    open: Boolean(blank),
    handleOpen: (blankId: IEquipmentMaintenanceBlank['id']) => setBlankIdQuery(blankId),
    clearBlankIdState: () => setBlankIdQuery(null),
  }
}

export default useViewMaintenanceBlankSidePageCtrl
